import type { AnyRoute } from '@tanstack/react-router';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

export const createDashboardsRoutes = <TParent extends AnyRoute>(
  parent: TParent
) => {
  const dashboardsRoute = createRoute({
    path: '/dashboards',
    getParentRoute: () => parent,
    component: lazyRouteComponent(() => {
      return import('./pages/DashboardsPage');
    })
  });

  return [dashboardsRoute];
};
